import Box from '@/components/UI/box/Box';
import styles from './FeaturesList.module.scss';
import Typography from '@/components/UI/typography/Typography';
import Icon from '@/components/UI/icon/Icon';
import Button from '@/components/UI/button/Button';
import FeaturesItemsSection from './featuresItemsSection/FeaturesItemsSection';
import { Control, SubmitHandler, UseFormHandleSubmit } from 'react-hook-form';
import { FC } from 'react';
import { MidTermFeatureData } from '../MidTermFeature';
import { MidTermFeatures } from '../../constants/midTermFeatures';
interface FeaturesListProps {
  handleClose: () => void;
  handleSubmit: UseFormHandleSubmit<MidTermFeatureData>;
  onSubmit: SubmitHandler<MidTermFeatureData>;
  handleResetFilter: (e: any) => void;
  control: Control<MidTermFeatureData>;
  midTermFeatures: MidTermFeatures[];
}
const FeaturesList: FC<FeaturesListProps> = ({
  handleClose,
  control,
  handleSubmit,
  onSubmit,
  handleResetFilter,
  midTermFeatures
}) => {
  return <Box className={styles['features-list-container']} data-sentry-element="Box" data-sentry-component="FeaturesList" data-sentry-source-file="FeaturesList.tsx">
      <Box className={styles['features-header']} data-sentry-element="Box" data-sentry-source-file="FeaturesList.tsx">
        <Box onClick={handleClose} className={styles['close-icon-section']} data-sentry-element="Box" data-sentry-source-file="FeaturesList.tsx">
          <Icon name="close" type="highEmphasis" size={'large'} data-sentry-element="Icon" data-sentry-source-file="FeaturesList.tsx" />
        </Box>
        <Typography variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="FeaturesList.tsx">انتخاب امکانات</Typography>
      </Box>
      <form id="hook-form" className={styles['features-form-container']} onSubmit={handleSubmit(onSubmit)}>
        <Box className={styles['features-list-section']} data-sentry-element="Box" data-sentry-source-file="FeaturesList.tsx">
          {midTermFeatures.map((item, index) => <FeaturesItemsSection control={control} item={item} key={'FEATURE_ITEM_' + index} fullList={true} />)}
        </Box>
        <Box className={styles['action-footer']} data-sentry-element="Box" data-sentry-source-file="FeaturesList.tsx">
          <Button format="outlined" onClick={handleResetFilter} data-sentry-element="Button" data-sentry-source-file="FeaturesList.tsx">
            پاک کردن{' '}
          </Button>

          <Button format="primary" size="medium" type="submit" data-sentry-element="Button" data-sentry-source-file="FeaturesList.tsx">
            اعمال فیلتر
          </Button>
        </Box>
      </form>
    </Box>;
};
export default FeaturesList;